
export enum ResultType {
    FlatTable = 'FlatTable',
    DrilldownSuperX = 'DrilldownTableSuperXStyle',
    DrilldownGroupable = 'DrilldownTableGroupable'
}
